export var CardTypes;
(function (CardTypes) {
    CardTypes["FavoriteCard"] = "favorite-card";
    CardTypes["ContentCard"] = "content-card";
    CardTypes["SearchContentCard"] = "search-content-card";
    CardTypes["ContactCard"] = "employee";
})(CardTypes || (CardTypes = {}));
